import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmModal = ({
  show,
  onHide,
  onConfirm,
  title,
  message,
  dangerNote = "* This action cannot be undone.",
  confirmText = "Yes",
  cancelText = "No",
  confirmVariant = "primary",
}) => {
  return (
    <Modal show={show} size="md" onHide={onHide}>
      <Modal.Header closeButton>
        <div className="modal-title h4">{title}</div>
      </Modal.Header>
      <Modal.Body className="text-center">
        <h5 className="mb-0">{message}</h5>
        {dangerNote && (
          <p className="text-danger">
            <span>*</span> {dangerNote}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant={confirmVariant} onClick={onConfirm}>
          {confirmText}
        </Button>
        <Button variant="secondary" onClick={onHide}>
          {cancelText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
